<button class="btn btn-added" (click)="openExportDialog()">
    Export
  </button>
  